import React from "react";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";
import { PageTitle } from "@/components/DashUI";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";

export default function Account() {
  const { user } = useAuth();
  const settings = useSettings();
  return (
    <div>
      <PageTitle title="Account" subtitle="Your profile and membership" />
      <div className="grid gap-6 lg:grid-cols-2">
        <Card className="p-6" data-testid="account-profile">
          <h3 className="font-heading font-semibold text-navy">Profile</h3>
          <dl className="mt-4 space-y-3 text-sm">
            <Row label="Name" value={user?.name} />
            <Row label="Email" value={user?.email} />
            <Row label="Role" value={user?.role} />
            <Row label="Status" value={user?.agent_status || "Membership active (Skool)"} />
          </dl>
        </Card>
        <Card className="p-6">
          <h3 className="font-heading font-semibold text-navy">Membership & Accelerator</h3>
          <p className="mt-3 text-sm text-slate-500">Membership {settings.membership_price} is managed through Skool.</p>
          <div className="mt-4 flex flex-col gap-3">
            <Button onClick={() => window.open(settings.skool_membership_url, "_blank")} className="bg-clinical hover:bg-clinical/90">
              Manage membership on Skool <ExternalLink className="ml-2 h-4 w-4" />
            </Button>
            <Button variant="outline" onClick={() => window.open(settings.skool_accelerator_url, "_blank")}>
              Business-in-a-Box — {settings.accelerator_price}
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
}
function Row({ label, value }) {
  return <div className="flex justify-between border-b border-slate-100 pb-2"><dt className="text-slate-500">{label}</dt><dd className="font-medium text-navy">{value}</dd></div>;
}
